import Abbreviations from "./abbreviations";

export default Abbreviations;